/* eslint-disable no-dupe-keys */
// prettier-ignore
module.exports = {
  /* Menu */
  "Dashboard" : "Bảng điều khiển",
 
};
